// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { screenCheckLinesCalendar16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-screen-check-lines-calendar': IconScreenCheckLinesCalendar;
    }
}

/**
 * The icon component for the 'screenCheckLinesCalendar' icon
 */
export class IconScreenCheckLinesCalendar extends IconSvg {
    public constructor() {
        super(screenCheckLinesCalendar16X16);
    }
}

registerIconSvg('icon-screen-check-lines-calendar', IconScreenCheckLinesCalendar);
export const iconScreenCheckLinesCalendarTag = 'nimble-icon-screen-check-lines-calendar';
